import React, { useCallback, useEffect, useMemo, useState } from 'react'
import Modal from '../../../common/modal'
import { Box, Button, Stack } from '@mui/material'
import { connect } from 'react-redux'
import { Item } from '../../../common/snippets'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import BookingScreenConfig from './BookingScreenConfig'
import BookingEventConfig from './BookingEventConfig'
import OtherEventsConfig from './OtherEventsConfig'
import CargoReportConfig from './CargoReportConfig'
import { useAtom } from 'jotai'
import {
  fetchCargoSettingAtoms,
  getCargoMpesaSettingData,
  getCargoSettingData,
  fetchUserListForLuggageSettingUpdateAtom,
  userListForLuggageSettingUpdateAtom,
} from '../../../common/jotaiState/mtplMaster'
import { defPaymentType, macAuthentication, saveInitialValueData } from './Constant'
import { PostRequest, PostRequestV2 } from '../../../common/api'
import { urls } from '../../../common/constants'
import { alertAtom, globalLoaderAtom } from '../../../common/jotaiState/globalStateAtoms'
import DropDownOA from '../../../common/dropDownOA'
import OTPModal from '../../BrnchUsrMaster/UserMaster/OTPModal'
import { decryptText } from '../../../common/loginDecode'
const ComapanyLuggageSettingModel = (props) => {
  const { dataForModel, updateModal, data, selEditLuggageSetting } = props
  const { common } = data
  const { loginData, showModal, modalType } = common
  const { intCompanyID } = loginData
  const [companySettingsEditData] = useAtom(getCargoSettingData)
  const [companyMpesaSettingData] = useAtom(getCargoMpesaSettingData)
  const [, getCompanySettingEdit] = useAtom(fetchCargoSettingAtoms)
  const [editSaveData, setEditSaveData] = useState(saveInitialValueData)
  const [, setAlert] = useAtom(alertAtom)
  const [approvalAuthorityList] = useAtom(userListForLuggageSettingUpdateAtom)
  const [, getUserList] = useAtom(fetchUserListForLuggageSettingUpdateAtom)
  const [selectedAuthority, setSelectedAuthority] = useState({})
  const [OTP, setOTP] = useState('')
  const [, setLoader] = useAtom(globalLoaderAtom)
  const [modal, setModal] = useState('')
  useEffect(() => {
    if (companySettingsEditData && Object.keys(companySettingsEditData).length > 0) {
      let defMAcAuthe = macAuthentication?.filter((obj) => obj.id === Number(companySettingsEditData.WebCargoEnabledMode))
      let defPayType = defPaymentType?.filter((obj) => obj.id === Number(companySettingsEditData.DefaultPaymentType))
      setEditSaveData({ ...companySettingsEditData, macDrop: defMAcAuthe?.[0]?.name || '', defaultPayType: defPayType?.[0]?.name || '' })
    }
  }, [companySettingsEditData])
  const modalStyle = useMemo(
    () => ({
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'start',
      paddingTop: '10px',
    }),
    []
  )
  const editRowData = useCallback(() => {
    const obj = {
      intCompanyID: selEditLuggageSetting.CompanyID,
      intBranchID: 0,
      intUserID: 0,
    }
    return getCompanySettingEdit(obj)
  }, [getCompanySettingEdit, selEditLuggageSetting.CompanyID])
  useEffect(() => {
    editRowData()
    getUserList()
  }, [editRowData, getUserList])
  const handleBrnhCargoValue = (value, field, rowFields) => {
    setEditSaveData((prev) => {
      const updated = { ...prev }
      updated[field] = value
      rowFields?.forEach((obj) => {
        updated[obj] = 0
      })
      return updated
    })
  }
  const handleSaveSetting = (extraData = {}, onSuccess = updateModal, successMessage = 'Comapany Luggage Setting Updated Successfully') => {
    if (editSaveData?.ChallanCopies === 0 || editSaveData?.ChallanCopies === '0') {
      setAlert({ show: true, success: true, msg: 'Challan copies cannot be 0', nextId: '' })
    } else {
      const payloadExtraData = extraData && typeof extraData === 'object' ? extraData : {}
      const obj = {
        intCompanyID: selEditLuggageSetting.CompanyID,
        intIsParty: editSaveData.IsParty,
        IsDescriptionDisable: editSaveData.IsDescriptionDisable,
        IsGoodsValueDisable: editSaveData.IsGoodsValueDisable,
        // intIsFreight: editSaveData.intIsFreight,
        IsCartageDisable: editSaveData.IsCartageDisable,
        IsDocumentDisable: editSaveData.IsDocumentDisable,
        IsInsuranceDisable: editSaveData.IsInsuranceDisable,
        RemoveValuation: editSaveData.RemoveValuation,
        IsInsuranceCompulsory: editSaveData.IsInsuranceCompulsory,
        intIsServiceTax: editSaveData.IsServiceTax,
        IsWeightDisable: editSaveData.IsWeightDisable,
        IsBillNoDisable: editSaveData.IsBillNoDisable,
        intIsManual: editSaveData.IsManual,
        intIsOnAccount: editSaveData.IsOnAccount,
        IsHamaliDisable: editSaveData.IsHamaliDisable,
        intIsDelCartage: editSaveData.IsDelCartage,
        IsCartageRemarkDisable: editSaveData.IsCartageRemarkDisable,
        intIsPartyForAllPayType: editSaveData.IsPartyForAllPayType,
        intIsPartyForSenderReceiver: editSaveData.IsPartyForSenderReceiver,
        GSTType: editSaveData.GstType,
        ChallanType: editSaveData.ChallanType,
        ChallanCopies: editSaveData.ChallanCopies,
        ReceiveType: editSaveData.ReceiveType,
        IsPartyDetailsMandatory: editSaveData.IsPartyDetailsMandatory,
        IsDispatchAutoReceive: editSaveData.CargoIsAutoReceiveDispatch,
        DispatchAutoReceiveDays: editSaveData.CargoAutoReceiveDispatchDays,
        IsBranchReceiveAutoReceive: editSaveData.CargoIsAutoReceiveBranchTransfer,
        BranchTransferAutoReceiveDays: editSaveData.CargoAutoReceiveBranchTransferDays,
        IsDelBranchChange: editSaveData.IsDelBranchChange,
        HasDeliveryType: editSaveData.IsDelivery,
        HasFTLBooking: editSaveData.HasFTLBooking,
        HasEwayBillNoDisable: editSaveData.HasEwayBillNoDisable,
        HasDetailsOnDelivery: editSaveData.HasDetailsOnDelivery,
        HasNoBeforeName: editSaveData.HasNoBeforeName,
        TotalStickerCopiesType: editSaveData.StickerCopiesType,
        HasWeightRoundUp: editSaveData.HasWeightRoundUp,
        HasFoCApproval: editSaveData.HasFoCApproval,
        ShowAllLrOption: editSaveData.ShowAllLrOption,
        HasGSTOnDelivery: editSaveData.HasGSTOnDelivery,
        IsSTAType: editSaveData.IsSTACompany,
        HasCrossingCity: editSaveData.HasCrossingCity,
        InsuranceProviderID: editSaveData.InsuranceProviderID,
        StickerType: editSaveData.StickerType,
        HasOwnBookingRestricted: editSaveData.HasOwnBookingRestricted,
        DefaultBookingPmtType: editSaveData.DefaultBookingPmtType,
        HasAutoCrossing: editSaveData.HasAutoCrossing,
        HasAutoReceive: editSaveData.HasAutoReceive,
        IsMOPDisable: editSaveData.IsMOPDisable,
        IsFocOTP: editSaveData.IsFocOtp,
        IsSMSForNearestBranch: editSaveData.IsSMSForNearestBranch,
        IsQRForBranchRecharge: editSaveData.IsQRForBranchRecharge,
        QRProviderID: editSaveData.QRProviderID,
        IsOnlyDispatchCities: editSaveData.IsOnlyDispatchCities,
        IsShowAdditional: editSaveData.IsShowAdditional,
        IsOperatorHamaliDisable: editSaveData.IsOperatorHamaliDisable,
        IsAllowJackUpOnQR: editSaveData.IsAllowJackUpOnQR,
        IsGSTIN_Directory: editSaveData.IsGSTIN_Directory,
        IsPickUpAndDropOffChg: editSaveData.IsPickUpAndDropOffChg,
        IsDropoffFeeDisable: editSaveData.IsDropoffFeeDisable,
        PickUpFeeDisable: editSaveData.PickUpFeeDisable,
        IsFreightCartageOptHamaliGST: editSaveData.IsFreightCartageOptHamaliGST,
        HideHiredVehicle: editSaveData.HideHiredVehicle,
        IsBusScheduleDispatchUpdate: editSaveData.IsBusScheduleDispatchUpdate,
        IsGoodsValueCompulsory: editSaveData.IsGoodsValueCompulsory,
        IsLimitOnUnitAndFreight: editSaveData.IsLimitOnUnitAndFreight,
        UseToPayAsCOD: editSaveData.UseToPayAsCOD,
        NoOfUnits: editSaveData.NoOfUnits,
        NoOfFreight: editSaveData.NoOfFreight,
        IsCashbookEnabled: editSaveData.IsCashbookEnabled,
        IsCashbookLimitEnabled: editSaveData.IsCashbookLimitEnabled,
        IsCashbookInOwnFranchEnabled: editSaveData.IsCashbookInOwnFranchEnabled,
        IsEnableOutForDelivery: editSaveData.IsEnableOutForDelivery,
        IsAllowMultCons: editSaveData.IsMultipleConsignment,
        IsBkngBrchUserForOfflineBkng: editSaveData.IsBookingBranchUserForOfflineBkng,
        IsLoginUserForOfflineBkng: editSaveData.IsLoggedInUserForOfflineBooking,
        IsCreditTopay: editSaveData.IsCreditTopay,
        MinCargoBookingFreight: editSaveData.MinCargoFrightAmt,
        IsMobNoInDispatchRpt: editSaveData.IsMobNoInDispatchRpt,
        IsHamInBookingRpt: editSaveData.IsHamInBookingRpt,
        IsDescInDispatchRpt: editSaveData.IsDescInDispatchRpt,
        IsCommentInDispatchRpt: editSaveData.IsCommentInDispatchRpt,
        IsEwayBillValidate: editSaveData.IsEwayBillValidate,
        IsConvChg: editSaveData.IsConvCharge,
        MinWeightPerLR: editSaveData.MinWeightPerLR,
        IsForceFTL: editSaveData.IsForceFTL,
        IsMinimumGoodsValue: editSaveData.IsMinimumGoodsValue,
        IsQRRechargeAmount: editSaveData.IsQRRechargeAmount,
        MinUnits: editSaveData.MinFTLUnits,
        MinWeight: editSaveData.MinFTLWeight,
        MinFreight: editSaveData.MinFTLFreight,
        MinGoodsValue: editSaveData.MinGoodsValue,
        MinQrAmount: editSaveData.MinQrAmount,
        WebCargoEnabledMode: editSaveData.WebCargoEnabledMode,
        IsGstValidation: editSaveData.BypassGSTINValidation,
        AllowMultiCityDispatch: editSaveData.AllowMultiCityDispatch,
        RemoveWebDispChallanInExeFormat: editSaveData.RemoveWebDispChallanInExeFormat,
        RechargeApprovalOTP: editSaveData.IsRechargeApprovalOTP,
        OnAccountCreditPortrait: editSaveData.OnAccountCreditPortrait,
        IsNonMovementPortrait: editSaveData.IsNonMovementPortrait,
        IsEwaybillReportPortrait: editSaveData.IsEwaybillReportPortrait,
        IsPartyBookingPortrait: editSaveData.IsPartyBookingPortrait,
        IsPartyBusinessPortrait: editSaveData.IsPartyBusinessPortrait,
        IsBranchCrlTxnsPortrait: editSaveData.IsBranchCrlTxnsPortrait,
        IsPartyCrlTxnsPortrait: editSaveData.IsPartyCrlTxnsPortrait,
        BookingReportPortrait: editSaveData.BookingReportPortrait,
        BranchTransferPortrait: editSaveData.BranchTransferPortrait,
        BranchTransferReceivePortrait: editSaveData.BranchTransferReceivePortrait,
        DispatchReportPortrait: editSaveData.DispatchReportPortrait,
        ReceiveReportPortrait: editSaveData.ReceiveReportPortrait,
        DeliveryReportPortrait: editSaveData.DeliveryReportPortrait,
        RefundReportPortrait: editSaveData.RefundReportPortrait,
        IsMobNoInDispatchRpt: editSaveData.IsMobNoInDispatchReport,
        IsDescInDispatchRpt: editSaveData.IsDescriptionInDispatchRep,
        IsHamInBookingRpt: editSaveData.IsHamaliInBookingReport,
        IsCommentInDispatchRpt: editSaveData.IsCommentInDispatchRep,
        UseFormattedLRinReports: editSaveData.UseFormattedLRinReports,
        IsAllowNonMovementReport: editSaveData.AllowNonMovementReport,
        IsNonMovProcessed: editSaveData.IsNonMovProcessed,
        IsUploadRchTxnReceipt: editSaveData.IsUploadRchTxnReceipt,
        EnableRechargeRequest: editSaveData.EnableRechargeRequest,
        BookingDeliveryWithQR: editSaveData.IsBookingDeliveryWithQR,
        FTLMinActWeight: editSaveData.FTLMinActWeight,
        HasPTLBooking: editSaveData.HasPTLBooking,
        IsSenderNoCompulsory: editSaveData.IsSenderNoCompulsory,
        IsSenderNoDisable: editSaveData.IsSenderNoDisable,
        IsSenderNoRemove: editSaveData.IsSenderNoRemove,
        IsSenderCityAndStateDisable: editSaveData.IsSenderCityAndStateDisable,
        IsSenderCityAndStateRemove: editSaveData.IsSenderCityAndStateRemove,
        IsSenderCityAndStateCompulsory: editSaveData.IsSenderCityAndStateCompulsory,
        RemoveSenderGSTIN: editSaveData.RemoveSenderGSTIN,
        IsSenderGSTINDisable: editSaveData.IsSenderGSTINDisable,
        IsSenderGSTINCompulsory: editSaveData.IsSenderGSTINCompulsory,
        RemoveSenderID: editSaveData.RemoveSenderID,
        IsSenderIDProofDisable: editSaveData.IsSenderIDProofDisable,
        IsSenderIDProofCompulsory: editSaveData.IsSenderIDProofCompulsory,
        IsRemoveSenderOtherInfo: editSaveData.IsRemoveSenderOtherInfo,
        IsSenderOtherInfoDisable: editSaveData.IsSenderOtherInfoDisable,
        IsSenderOtherInfoCompulsory: editSaveData.IsSenderOtherInfoCompulsory,
        IsRemoveReceiverOtherInfo: editSaveData.IsRemoveReceiverOtherInfo,
        IsReceiverOtherInfoDisable: editSaveData.IsReceiverOtherInfoDisable,
        IsReceiverOtherInfoCompulsory: editSaveData.IsReceiverOtherInfoCompulsory,
        RemoveHomePickup: editSaveData.RemoveHomePickup,
        IsHomePickUpDisable: editSaveData.IsHomePickUpDisable,
        IsHomePickUpCompulsory: editSaveData.IsHomePickUpCompulsory,
        RemoveBillInfo: editSaveData.RemoveBillInfo,
        IsBillNoCompulsory: editSaveData.IsBillNoCompulsory,
        RemoveEwayBillNo: editSaveData.RemoveEwayBillNo,
        IsEwayBillCompulsory: editSaveData.IsEwayBillCompulsory,
        IsRecvNoCompulsory: editSaveData.IsRecvNoCompulsory,
        IsReceiverNoDisable: editSaveData.IsReceiverNoDisable,
        IsReceiverNoRemove: editSaveData.IsReceiverNoRemove,
        IsRecCityAndStateDisable: editSaveData.IsRecCityAndStateDisable,
        IsRecCityAndStateRemove: editSaveData.IsRecCityAndStateRemove,
        IsRecCityAndStateCompulsory: editSaveData.IsRecCityAndStateCompulsory,
        RemoveReceiverGSTIN: editSaveData.RemoveReceiverGSTIN,
        IsRecGSTINDisable: editSaveData.IsRecGSTINDisable,
        IsRecGSTINCompulsory: editSaveData.IsRecGSTINCompulsory,
        RemoveHomeDelivery: editSaveData.RemoveHomeDelivery,
        IsHomeDeliveryDisable: editSaveData.IsHomeDeliveryDisable,
        IsHomeDeliveryCompulsory: editSaveData.IsHomeDeliveryCompulsory,
        RemoveCartageremark: editSaveData.RemoveCartageremark,
        IsCartageRemarkCompulsory: editSaveData.IsCartageRemarkCompulsory,
        RemoveComment: editSaveData.RemoveComment,
        IsCommentRemove: editSaveData.IsCommentRemove,
        IsCommentCompulsory: editSaveData.IsCommentCompulsory,
        RemovePaymentMode: editSaveData.RemovePaymentMode,
        IsPaymentModeDisable: editSaveData.IsPaymentModeDisable,
        IsPaymentModeCompulsory: editSaveData.IsPaymentModeCompulsory,
        RemoveAccountnumber: editSaveData.RemoveAccountnumber,
        IsAccountNoDisable: editSaveData.IsAccountNoDisable,
        IsAccountNoCompulsory: editSaveData.IsAccountNoCompulsory,
        RemoveReferenceID: editSaveData.RemoveReferenceID,
        IsReferenceIDDisable: editSaveData.IsReferenceIDDisable,
        IsReferenceIDCompulsory: editSaveData.IsReferenceIDCompulsory,
        RemoveDescription: editSaveData.RemoveDescription,
        IsDescriptionCompulsory: editSaveData.IsDescriptionCompulsory,
        RemovePackMethod: editSaveData.RemovePackMethod,
        IsPackMethodCompulsory: editSaveData.IsPackMethodCompulsory,
        RemoveGoodsvalue: editSaveData.RemoveGoodsvalue,
        RemoveActualWeight: editSaveData.RemoveActualWeight,
        IsActualWeightCompulsory: editSaveData.IsActualWeightCompulsory,
        RemoveCFTWeight: editSaveData.RemoveCFTWeight,
        IsCFTWeightCompulsory: editSaveData.IsCFTWeightCompulsory,
        IsCFTWeightDisable: editSaveData.IsCFTWeightDisable,
        RemoveChargeWeight: editSaveData.RemoveChargeWeight,
        IsChargedWeightDisable: editSaveData.IsChargedWeightDisable,
        IsChargedWeightCompulsory: editSaveData.IsChargedWeightCompulsory,
        RemoveBookingPageRate: editSaveData.RemoveBookingPageRate,
        IsBookingPageRateDisable: editSaveData.IsBookingPageRateDisable,
        IsBookingPageRateCompulsory: editSaveData.IsBookingPageRateCompulsory,
        IsFreightRemove: editSaveData.IsFreightRemove,
        IsFreightRemoveCompulsory: editSaveData.IsFreightRemoveCompulsory,
        RemovePickupcartage: editSaveData.RemovePickupcartage,
        IsPickUpCartageCompulsory: editSaveData.IsPickUpCartageCompulsory,
        RemoveMisccartage: editSaveData.RemoveMisccartage,
        IsMiscChgRemove: editSaveData.IsMiscChgRemove,
        IsMiscCompulsory: editSaveData.IsMiscCompulsory,
        RemoveBookingDropcartage: editSaveData.RemoveBookingDropcartage,
        IsDropCartageDisable: editSaveData.IsDropCartageDisable,
        IsDropCartageCompulsory: editSaveData.IsDropCartageCompulsory,
        IsBookingHamaliCompulsory: editSaveData.IsBookingHamaliCompulsory,
        RemoveHamali: editSaveData.RemoveHamali,
        IsBookingOpHamaliCompulsory: editSaveData.IsBookingOpHamaliCompulsory,
        RemoveOpHamali: editSaveData.RemoveOpHamali,
        RemoveDocfee: editSaveData.RemoveDocfee,
        IsDocumentFeeCompulsory: editSaveData.IsDocumentFeeCompulsory,
        RemovePickupfee: editSaveData.RemovePickupfee,
        RemoveDropofffee: editSaveData.RemoveDropofffee,
        IsPickupFeeCompulsory: editSaveData.IsPickupFeeCompulsory,
        IsDropoffFeeCompulsory: editSaveData.IsDropoffFeeCompulsory,
        IsConvChgCompulsory: editSaveData.IsConvChgCompulsory,
        IsConvChgDisable: editSaveData.IsConvChgDisable,
        SetDefaultBookCargo: editSaveData.SetDefaultBookCargo,
        SetDefaultYesOnPrint: editSaveData.SetDefaultYesOnPrint,
        IsBookingWithEwayBill: editSaveData.IsBookingWithEwayBill,
        intIsCollChg: editSaveData.IsCollChg,
        HasCartageBreakup: editSaveData.HasCartageBreakup,
        HasContactNoCompulsory: editSaveData.HasContactNoCompulsory,
        IsDemurrage: editSaveData.IsDemurrage,
        IsExtraHamali: editSaveData.IsExtraHamali,
        IsSTACode: editSaveData.IsSTACode,
        DefaultBookingPmtType: editSaveData.DefaultPaymentType,
        IsFreightDisable: editSaveData.IsFreightDisable,
        IsFreightRemoveCompulsory: editSaveData.IsFreightRemoveCompulsory,
        RemoveQRTransFeeFromCustAmt: editSaveData.RemoveQRTransFeeFromCustAmt,
        IsOpenCargoWeb: editSaveData?.IsOpenCargoWeb,
        BranchRechargeAcceptOtpNo: editSaveData?.BranchRechargeAcceptOtpNo,
        ...payloadExtraData,
      }
      PostRequest(urls.cargoCompanySettingsInsertUpdate, obj).then((res) => {
        if (res.status === 'Success') {
          setAlert({ show: true, success: true, msg: successMessage, nextId: '' })
          onSuccess?.()
        } else {
          setAlert({ show: true, msg: res.ErrMessage, nextId: '' })
        }
      })
    }
  }
  const handleSave = () => {
    if (selectedAuthority?.UserID) {
      const obj = {
        CompanyID: intCompanyID,
        EventType: 'Company Edit',
        intUserID: selectedAuthority.UserID,
        MobileNo: editSaveData.MobileNo,
      }
      setLoader(true)
      PostRequestV2(urls.OTPForCompanySettingsUpdate, obj)
        .then((res) => {
          if (res.Status === true) {
            const otp = decryptText(res.OTP)
            if (otp) {
              setOTP(otp)
              setModal('OTPPopup')
            }
          } else {
            setAlert({ show: true, msg: res.ErrMessage, nextId: '' })
          }
        })
        .catch((error) => {
          console.error(error)
        })
        .finally(() => {
          setLoader(false)
        })
    } else {
      setAlert({ show: true, msg: 'Please select approval authority' })
    }
  }
  return (
    <>
      <Modal
        headTxt={dataForModel.headText}
        width={'98%'}
        updateModal={updateModal}
        closeId={'closeButton'}
        modalClass={'booking-popup'}
        modalStyle={modalStyle}
      >
        <Box className="BranchPageTabContainer scrollBlue" sx={{ maxHeight: '90vh', overflowY: 'auto', padding: '10px' }}>
          <Stack
            style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', justifyContent: 'space-between', alignItems: 'center' }}
          >
            <div style={{ fontFamily: 'Roboto', fontWight: 'bold', fontSize: '16px', color: '#444444', width: '33%', fontWeight: '700' }}>
              Selected Company: {selEditLuggageSetting?.CompanyName}
            </div>
            <div
              style={{
                fontFamily: 'Roboto',
                fontWight: 'bold',
                fontSize: '16px',
                color: '#444444',
                width: '33%',
                textAlign: 'center',
                fontWeight: '700',
              }}
            >
              COMPANY LUGGAGE SETTINGS
            </div>
            <div
              style={{
                width: '33%',
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'nowrap',
                justifyContent: 'space-between',
                gap: '15px',
                alignItems: 'center',
              }}
            >
              <Item className="input--wrapper" sx={{ ...sx.itemsx, width: '50%' }}>
                <DropDownOA
                  width="100%"
                  label="Approval Authority"
                  data={approvalAuthorityList}
                  idKey="UserID"
                  dataKey="UserName"
                  value={selectedAuthority?.UserName}
                  onSelect={setSelectedAuthority}
                />
              </Item>
              <Button
                id="saveSettings"
                style={{ margin: '0', height: '40px', width: '50%' }}
                className="btn add-btn"
                variant="contained"
                color="error"
                onClick={handleSave}
                onKeyDown={(e) => {}}
              >
                Save Settings
              </Button>
            </div>
          </Stack>
          <Stack style={{ display: 'flex', flexDirection: 'column', paddingTop: '15px' }}>
            <div
              variant="h6"
              style={{
                textAlign: 'center',
                backgroundColor: '#DAEDFE',
                fontFamily: 'Roboto',
                fontWeight: 600,
                fontSize: '14px',
                color: '#444',
                padding: '8px 8px 0px 8px',
                marginBottom: '0px',
                width: '100%',
              }}
            >
              BOOKING SCREEN CONFIG
            </div>
            <BookingScreenConfig
              setEditSaveData={setEditSaveData}
              editSaveData={editSaveData}
              handleBrnhCargoValue={handleBrnhCargoValue}
              updateModal={updateModal}
              showModal={showModal}
              modalType={modalType}
              common={common}
              selEditLuggageSetting={selEditLuggageSetting}
            />
          </Stack>
          <Stack style={{ display: 'flex', flexDirection: 'column', paddingTop: '15px' }}>
            <div
              variant="h6"
              style={{
                textAlign: 'center',
                backgroundColor: '#DAEDFE',
                fontFamily: 'Roboto',
                fontWeight: 600,
                fontSize: '14px',
                color: '#444',
                padding: '8px 8px 0px 8px',
                marginBottom: '0px',
                width: '100%',
              }}
            >
              BOOKING EVENT CONFIG
            </div>
            <BookingEventConfig setEditSaveData={setEditSaveData} editSaveData={editSaveData} handleBrnhCargoValue={handleBrnhCargoValue} />
          </Stack>
          <Stack style={{ display: 'flex', flexDirection: 'column', paddingTop: '15px' }}>
            <div
              variant="h6"
              style={{
                textAlign: 'center',
                backgroundColor: '#DAEDFE',
                fontFamily: 'Roboto',
                fontWeight: 600,
                fontSize: '14px',
                color: '#444',
                padding: '8px 8px 0px 8px',
                marginBottom: '0px',
                width: '100%',
              }}
            >
              OTHER EVENTS CONFIG
            </div>
            <OtherEventsConfig
              setEditSaveData={setEditSaveData}
              editSaveData={editSaveData}
              handleBrnhCargoValue={handleBrnhCargoValue}
              loginData={loginData}
              selEditLuggageSetting={selEditLuggageSetting}
              companyMpesaSettingData={companyMpesaSettingData}
              handleSaveSetting={handleSaveSetting}
              refreshCargoSettingData={editRowData}
            />
          </Stack>
          <Stack style={{ display: 'flex', flexDirection: 'column', paddingTop: '15px' }}>
            <div
              variant="h6"
              style={{
                textAlign: 'center',
                backgroundColor: '#DAEDFE',
                fontFamily: 'Roboto',
                fontWeight: 600,
                fontSize: '14px',
                color: '#444',
                padding: '8px 8px 0px 8px',
                marginBottom: '0px',
                width: '100%',
              }}
            >
              CARGO REPORTS CONFIG
            </div>
            <CargoReportConfig setEditSaveData={setEditSaveData} editSaveData={editSaveData} handleBrnhCargoValue={handleBrnhCargoValue} />
          </Stack>
        </Box>
      </Modal>
      {modal === 'OTPPopup' ? <OTPModal saveApi={handleSaveSetting} OTP={OTP} sendOTPRequest={handleSave} updateModal={setModal} /> : <></>}
    </>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = {}
export default connect(mapStateToProps, mapDispatchToProps)(ComapanyLuggageSettingModel)
